import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { BuildingService } from 'src/app/app/building/building.service';
import { CompanyService } from 'src/app/app/company/company.service';
import { ParkingReportService } from '../parking-report.service';
import { Animations } from 'src/app/_helpers/animations';
import { ParkingReportType } from '../parking-report.model';

@Component({
  selector: 'app-parking-report-modal-filter',
  templateUrl: './parking-report-modal-filter.component.html',
  styleUrls: ['./parking-report-modal-filter.component.scss'],
  animations: [Animations.animeHeight, Animations.animeRotate],
})
export class ParkingReportModalFilterComponent implements OnInit {

  showBuildings: boolean = false;
  showCompanies: boolean = false;
  showDates: boolean = false;

  constructor(
    public modalCtrl: ModalController,
    public translate: TranslateService,
    public p: ThisPlatform,
    public parkingReportServ: ParkingReportService,
    public buildingServ: BuildingService,
    public companyServ: CompanyService,
  ) { }

  ngOnInit() { }

  onFilterBuilding($event) { 
    this.parkingReportServ.request.building = $event;
    this.parkingReportServ.reloadFilter(true);
  }

  onFilterCompany($company) {
    this.parkingReportServ.request.company = $company;
    this.parkingReportServ.reloadFilter(true);
  }

  onFilterDate(date, whichDate: string = "start" || "end") {
    if (whichDate == "start") {
      this.parkingReportServ.request.dateFrom = date;
    } else if (whichDate == "end") {
      this.parkingReportServ.request.dateTo = date;
    }

    this.parkingReportServ.reloadFilter(true);
  }

  onCloseModal() {
    this.modalCtrl.dismiss();
  }

  onClearFilters() {
    this.parkingReportServ.reloadFilter(false);
  }

  ngOnDestroy() { }

}
